import { pick } from "lodash";
import { User, UserProfile } from "../Model";

export const userProfileToUser = (profile: UserProfile): User => {
  return pick(profile, ['id', 'email', 'name', 'organisationId'])
}